import { createSelector } from 'reselect';
export const selectAccountState = createSelector((state) => state.account, account => account);
